<template>
  <div id="app">
<!--    <guide-open-app-alert :mask-closable="true" ref="guideAppToast"></guide-open-app-alert>-->
    <guide-browser-open></guide-browser-open>
    <!-- 缓存的页面 -->
    <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <!-- 不缓存的页面 -->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
import guideOpenAppAlert from '@/components/guideOpenAppAlert/guideOpenAppAlert.vue';
import guideBrowserOpen from '@/components/guideBrowserOpen/guideBrowserOpen.vue';
import { checkLogin } from '@/api/api';
import { isWechat, isYoJiangApp } from '@/common/js/utils';

export default {
  components: {
    // guideOpenAppAlert,
    guideBrowserOpen,
  },
  async created() {
    // 保存刚进入页面时的路径
    sessionStorage.wxBaseUrl = JSON.stringify(window.location.href);

    // 如果使用微信打开，没有登录，则自动登录
    if (isWechat()) {
      const res = await checkLogin().catch(() => false);
      if (res === false) {
        return;
      }

      const { data } = res;

      if (!data.result) {
        // eslint-disable-next-line no-restricted-globals
        location.href = data.login_url;
      }
    }
  },
  mounted() {
    if (!isYoJiangApp()) {
      checkLogin().then((res) => {
        if (!res.data.result) {
          return;
        }

        this.$store.dispatch('getUserData');
      });
    }
  }
};
</script>
<style lang="stylus">
  body {
    margin: 0 auto !important;
    max-width 750px
    min-width 320px
    font-size: 16px
    line-height: 1.5
    color: #4a4a4a
  }

  #nav
    position: relative
    z-index: 1
    padding 30px
    display: flex
    align-items: center
    justify-content: center
    a
      display: inline-flex
      padding: 10px 20px
      font-weight bold
      color #2c3e50
      &.router-link-exact-active
        color #42b983

  ._lazy_placeholder {
    display: inline-flex
    align-items: center
    justify-content: center
    margin: auto
    background: #eee url(./common/images/loading.gif) center center no-repeat
    background-size: 32px
  }

  .article-main-pal {
      img {
        max-width: 100%
      }
      .img-loading {
        background-color: #eeedeb;
        border: 1px solid #eeedeb;
        background-size: 22px;
        background-position: center center;
        background-repeat: no-repeat;
        background-image: url(./common/images/loading.gif);
      }
      .img-loadederror {
        background-color: #eeedeb;
        border: 1px solid #eeedeb;
        background-size: 40px;
        background-position: center center;
        background-repeat: no-repeat;
        background-image: url(./common/images/loadederror.png);
      }
  }
  [v-cloak] {
    display: none !important
  }
</style>
